<template lang="html">
  <v-container fluid>
    <v-row>
      <v-col cols="12" sm="6" offset-sm="3" md="4" offset-md="4">
        <h2 class="headline">
          <span class="font-weight-bold d-flex align-center">
            {{ $t('select_type_verification') }}
          </span>
        </h2>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="6" offset="3" sm="4" offset-sm="4" md="4" offset-md="4" class="text-center">
        <p class="caption line-height-regular">
          {{ $t('verification_code_instruction') }}
        </p>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="6" offset="3" sm="4" offset-sm="4" md="4" offset-md="4" class="text-center">
        <v-card class="mx-auto elevation-5" @click="verifyPhone()">
          <v-card-text class="d-flex flex-column align-center">
            <v-img src="@/assets/images/svg/phone.svg" height="48" width="64" contain />
            <div class="mt-2">
              {{ $t('call') }}
            </div>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col cols="6" offset="3" sm="4" offset-sm="4" md="4" offset-md="4" class="text-center">
        <v-card class="mx-auto elevation-5" @click="verifySms()">
          <v-card-text class="d-flex flex-column align-center">
            <v-img src="@/assets/images/svg/mail.svg" height="48" width="64" contain />
            <div class="mt-2">
              {{ $t('sms') }}
            </div>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import {
  sendOtp as sendOtpCustomer
} from '@/api/auth'
export default {
  data() {
    return {
      data_verification: {}
    }
  },
  created() {
    this.data_verification = this.$store.state.data_verification
  },
  methods: {
    async verifySms() {
      try {
        const obj = {
          otp_type: 1,
          phone: this.data_verification.value.phone
        }
        await sendOtpCustomer(obj)
        this.$store.state.loading_axios = false
        this.$store.dispatch('save_type_verification', 'sms')
        this.$router.push({ name: 'verification_otp_login', query: { redirect: this.$route.query.redirect }}).catch(() => {})
      } catch (e) {
        this.$store.state.show_error = true
        this.$store.state.error_message = e.string
        this.$store.state.error_type = e.statusCode
      }
    },
    async verifyPhone() {
      this.$router.push({ name: 'call_verification_login', query: { redirect: this.$route.query.redirect }}).catch(() => {})
    }
  }
}
</script>
